// extracted by mini-css-extract-plugin
export default {"socialShareBoxWrapper":"y_nI1"};